import Footer from "../Footer";
import Navbar from "../Navbar";
import "./UserDashboard.css";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { developAxios } from "../../axios.config";
import { SuperAdminStyledDiv } from "./css/SuperAdmin.styled";

const SuperAdmin = () => {
	const [card, setCard] = useState([]);
	useEffect(() => {
		developAxios(localStorage.getItem("token"))
			.get("/superadmin/cards/view")
			.then(({ data }) => {
				console.log(data.cards);
				setCard(data.cards);
				//         const expiry_time=12*60*60*1000;
				//      const timer =   setTimeout(()=>{
				// localStorage.removeItem("token")
				// console.log("token")
				// window.location.href="/signin"
				//         }, expiry_time)
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	return (
		<>
			<Navbar />
			<h3 className="my-5 text-center">SuperAdmin Dashboard</h3>
			<SuperAdminStyledDiv className="container">
				<div className="row">
					{card.map((item, i) => {
						if (item.hidden === true) return <></>;
						return (
							<>
								<div className="col-lg-3 col-sm-6" key={i}>
									<div className="card-box bg-sky-300">
										<div className="inner">
											<h3 className="one-line">
												<span>{item.name}</span>
											</h3>
											<p>{item.description}</p>
										</div>
										<Link
											className="card-box-footer"
											to={item.route}
										>
											open
											<i className="fa fa-arrow-circle-right"></i>
										</Link>
									</div>
								</div>
							</>
						);
					})}
				</div>
			</SuperAdminStyledDiv>
			<Footer />
		</>
	);
};

export default SuperAdmin;
